export default __webpack_public_path__ + "assets/30f25d723190a218d77bf1a81e3ca01a.jpg";